import React from "react";
import { Grid } from "@mui/material";
import { useIntl } from "react-intl";

import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { SelectInput } from "@dzambalaorg/mui-inputs-core";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import {
  IStakingRuleDepositSearchDto,
  IStakingRuleRewardSearchDto,
  ModuleType,
  StakingDepositTokenType,
  StakingRewardTokenType,
} from "@framework/types";
import { FormGrid } from "@dzambalaorg/ui-kit";

const initialValues = {
  contractIds: [],
  deposit: {
    tokenType: [] as Array<StakingDepositTokenType>,
  } as IStakingRuleDepositSearchDto,
  reward: {
    tokenType: [] as Array<StakingRewardTokenType>,
  } as IStakingRuleRewardSearchDto,
};

export const StakingRulesSearchForm = () => {
  const { formatMessage } = useIntl();

  return (
    <SearchWithFilters initialValues={initialValues as any}>
      <FormGrid
        columns={[1, 2]}
        containerProps={{ sx: theme => ({ marginTop: theme.spacing(theme.tokens.spacing.xl) }) }}
      >
        <EntityInput
          name="contractIds"
          controller="contracts"
          multiple
          fetchData={{ contractModule: [ModuleType.STAKING] }}
        />
        <SelectInput
          multiple
          name="deposit.tokenType"
          options={StakingDepositTokenType}
          label={formatMessage({ id: "form.labels.deposit" })}
        />
        <SelectInput
          multiple
          name="reward.tokenType"
          options={StakingRewardTokenType}
          label={formatMessage({ id: "form.labels.reward" })}
        />
      </FormGrid>
    </SearchWithFilters>
  );
};
